module.exports = __webpack_public_path__ + "static/media/1542318528311-479316346 - Citizen Datasteward.f490a174.jpg";